import React from "react";
import { Box } from "@mui/material";
import { MainContentWrapper, TableWrapper } from "../../../components/common/Common.styles";
import ServerSideTableColumnHeader from "../../../components/common/table/ServerSideTableColumnHeader";
import { ServerSidePagination } from "../../../components/common/table/ServerSidePagination";
import { LeaderboardEntry } from "../../../types/serviceModuleTypes";
import { PaginatedData } from "../../../hooks/PaginationHooks";
import LeaderboardTableRow from "./LeaderboardTableRow";
import { useTranslation } from "react-i18next";

interface LeaderboardTableProps {
    paginatedData: PaginatedData<LeaderboardEntry>;
}

const LeaderboardTable: React.FC<LeaderboardTableProps> = ({ paginatedData }) => {
    const { t } = useTranslation();

    return (
        <MainContentWrapper>
            <TableWrapper
                columnsTemplate="0.7fr 1.5fr 1.5fr 1.5fr 1fr 1fr"
                minWidth="900px"
            >
                <Box sx={{ display: "contents" }}>
                    <ServerSideTableColumnHeader
                        label={t("serviceModulesPage.leaderboardPage.table.rank")}
                        fieldName="rank"
                        isSorted
                        paginatedData={paginatedData}
                        firstCol
                    />
                    <ServerSideTableColumnHeader
                        label={t("serviceModulesPage.leaderboardPage.table.firstName")}
                        fieldName="firstName"
                        isSorted
                        paginatedData={paginatedData}
                    />
                    <ServerSideTableColumnHeader
                        label={t("serviceModulesPage.leaderboardPage.table.lastName")}
                        fieldName="lastName"
                        isSorted
                        paginatedData={paginatedData}
                    />
                    <ServerSideTableColumnHeader
                        label={t("serviceModulesPage.leaderboardPage.table.position")}
                        fieldName="position"
                        isSorted
                        paginatedData={paginatedData}
                    />
                    <ServerSideTableColumnHeader
                        label={t("serviceModulesPage.leaderboardPage.table.employeeNumber")}
                        fieldName="employeeNumber"
                        isSorted
                        paginatedData={paginatedData}
                    />
                    <ServerSideTableColumnHeader
                        label={t("serviceModulesPage.leaderboardPage.table.score")}
                        fieldName="score"
                        isSorted
                        paginatedData={paginatedData}
                        lastCol
                    />
                </Box>

                <Box sx={{ display: "contents" }}>
                    {paginatedData.items.map((item) => (
                        <LeaderboardTableRow key={item.id} item={item} />
                    ))}
                </Box>
            </TableWrapper>
            <ServerSidePagination paginatedData={paginatedData} />
        </MainContentWrapper>
    );
};

export default LeaderboardTable;
